<template>
  <div v-if="authStateResolved">
    <div v-if="authUser" class="person">
      <span class="person__email">Signed in as {{authUser.email}}</span>
      <a class="person__signout" href="javacript:;" @click="signOut">Sign out</a>
    </div>
    <div v-else>
      <!--
      <form @submit.prevent="register">
        <h2>Register</h2>
        <input type="email" v-model="email" placeholder="Type your email">
        <input type="password" v-model="password" placeholder="Pick your password">
        <button>Register</button>
      </form>
      -->
      <form class="login-form" @submit.prevent="signIn">
        <span class="login-form__name">Sign in</span>
        <input class="login-form__input" type="email"
          v-model="email" placeholder="Type your email" />
        <input class="login-form__input" type="password"
          v-model="password" placeholder="Type your password" />
        <button class="login-form__btn">Sign In</button>
      </form>
      <!--
      <div>
        <h2>Sign in with Google</h2>
        <button @click="signInWithGoogle">Sign In</button>
      </div>
      -->
    </div>
  </div>
  <div v-else>
    <p>checking auth state</p>
  </div>
</template>
<script>
/* eslint no-console: 0 */
// https://github.com/vueschool/vuejs-firebase-authentication/blob/master/index.html
import firebase from '@firebase/app';
import '@firebase/auth';

export default {
  data() {
    return {
      email: '',
      password: '',
      displayName: '',
      authUser: null,
      authStateResolved: false,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$emit('onAuthStateChanged', user);
      this.authStateResolved = true;
      this.authUser = user;
      if (user) {
        this.displayName = user.displayName;
        this.email = user.email;
      } else {
        this.displayName = '';
        this.email = '';
      }
    });
  },
  methods: {
    signIn() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .catch(console.error);
    },
    signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider)
        .catch(console.error)
        .then(data => console.log(data.user, data.credential.accessToken));
    },
    signOut() {
      firebase.auth().signOut();
    },
  },
};
</script>

<style lang="scss">
.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__name, &__btn, &__input {
    margin-top: 2px;
  }

  @media only screen and (min-width: 560px) {
    flex-direction: initial;
    justify-content: center;
    &__name, &__btn, &__input {
      margin-left: 10px;
    }
  }
}

.person {
  font-size: small;
  display: flex;
  justify-content: flex-end;
  &__email, &__signout {
    margin-right: 10px;
  }
}
</style>
